import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import AuthPage from '@/pages/AuthPage';
import MarketplaceClient from '@/marketplace/MarketplaceClient';
import ProductDetailPage from '@/pages/ProductDetailPage';
import DashboardClient from '@/dashboard/DashboardClient';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboardClient from '@/admin/AdminDashboardClient';
import NotFoundPage from '@/pages/NotFoundPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/marketplace" element={<MarketplaceClient />} />
      <Route path="/marketplace/:id" element={<ProductDetailPage />} />
      <Route path="/dashboard" element={<DashboardClient />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminDashboardClient />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
